const getEmailTemplate = (data) => `
    <strong>Name: </strong> ${data.name ? data.name : ''} <br/>
    <strong>Email: </strong> ${data.email ? data.email : ''} <br/>
    <strong>Message: </strong> ${data.message ? data.message : ''} <br/>`;

export default getEmailTemplate;
